module.exports = __webpack_public_path__ + "static/media/patrol.e320563a.png";